
/**
 * typed-contracts v2.4.0
 * Validation with good Flow and TypeScript type inference
 */

'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var valueToString = function valueToString(value) {
  if (Number.isNaN(value)) return 'NaN';
  if (typeof value == 'function') return '[Function]'; // $FlowFixMe

  if (_typeof(value) == 'symbol') return value.toString();

  switch (value) {
    case Infinity:
      return Infinity.toString();

    case -Infinity:
      return (-Infinity).toString();

    case undefined:
      return 'undefined';

    case null:
      return 'null';

    default:
      return "".concat(JSON.stringify(value), " (").concat(_typeof(value), ")");
  }
};

var typesToString = function typesToString(expectedTypes) {
  return expectedTypes.slice(0, -2).concat(expectedTypes.slice(-2).join(' or ')).join(', ');
};

var ValidationError = /*#__PURE__*/function (_TypeError) {
  _inherits(ValidationError, _TypeError);

  var _super = _createSuper(ValidationError);

  /* :: +valueName: string; */

  /* :: +expectedTypes: $ReadOnlyArray<string>; */

  /* :: +value: mixed; */

  /* :: +nested: $ReadOnlyArray<ValidationError>; */
  function ValidationError(valueName, value) {
    var _this;

    var expectedTypes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var nested = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

    _classCallCheck(this, ValidationError);

    _this = _super.call(this);
    _this.name = 'ValidationError';
    _this.valueName = valueName;
    _this.value = value;
    _this.expectedTypes = [].concat(expectedTypes);
    _this.nested = nested;

    if (_this.expectedTypes.length) {
      _this.message = _this.nested.length ? "".concat(_this.expectedTypes[0], " ").concat(_this.valueName, " have ").concat(_this.nested.length, " nested validation errors") : "`".concat(_this.valueName, "` must be ").concat(typesToString(_this.expectedTypes), ", but ").concat(valueToString(value), " given");
    }

    return _this;
  }

  return ValidationError;
}( /*#__PURE__*/_wrapNativeSuper(TypeError));

// eslint-disable-next-line no-redeclare
function curry2(fn) {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return args.length > 1 ? fn(args[0], args[1]) : function (value) {
      return fn(args[0], value);
    };
  };
}

function of
/* :: <T> */
(validate) {
  var maybe = curry2(function (valueName, value) {
    return value == null ? value : validate(valueName, value);
  });
  var optional = curry2(function (valueName, value) {
    return value === undefined ? value : validate(valueName, value);
  });

  var contract = function contract() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    if (args.length > 1) return validate(args[0], args[1]);

    var result = function result(value) {
      return validate(args[0], value);
    };

    result.maybe = maybe(args[0]);
    result.optional = optional(args[0]);
    return result;
  };

  var mapResult = function mapResult(transform) {
    return curry2(function (valueName, value) {
      return transform(validate(valueName, value));
    });
  };

  var match = function match(fromValue, fromError) {
    return curry2(function (valueName, value) {
      var result = validate(valueName, value);
      return result instanceof ValidationError ? fromError(result) : fromValue(result);
    });
  };

  contract.maybe = maybe;
  contract.optional = optional;
  contract.mapResult = mapResult;
  contract.match = match;
  return contract;
}

var literal = function literal(expectedValue) {
  return of(function (valueName, value) {
    return value === expectedValue || Number.isNaN(value) && Number.isNaN(expectedValue) ? value : new ValidationError(valueName, value, JSON.stringify(expectedValue));
  });
};
var isLiteral = literal;
var passLiteral = literal;
var lit = literal;
var isLit = literal;
var passLit = literal;

var UnionError = /*#__PURE__*/function (_ValidationError) {
  _inherits(UnionError, _ValidationError);

  var _super = _createSuper(UnionError);

  function UnionError(valueName, value, errors) {
    var _this;

    _classCallCheck(this, UnionError);

    _this = _super.call(this, valueName, value, 'Union', errors);
    _this.name = 'UnionError';
    return _this;
  }

  return UnionError;
}(ValidationError);
var union = function union() {
  for (var _len = arguments.length, rules = new Array(_len), _key = 0; _key < _len; _key++) {
    rules[_key] = arguments[_key];
  }

  var validators = rules.map(function (rule) {
    return typeof rule == 'function' ? rule : literal(rule);
  });

  var unionContract = function unionContract(name, value) {
    var errors = validators.map(function (validate) {
      return validate(name, value);
    }).reduce(function (scope, error) {
      if (error instanceof ValidationError) scope.push(error);
      return scope;
    }, []);
    return errors.length < validators.length ? value : new UnionError(name, value, errors);
  };

  return of(unionContract);
};
var isUnion = union;
var passUnion = union;
var uni = union;
var isUni = union;
var passUni = union;

var ArrayValidationError = /*#__PURE__*/function (_ValidationError) {
  _inherits(ArrayValidationError, _ValidationError);

  var _super = _createSuper(ArrayValidationError);

  function ArrayValidationError(valueName, value, errors) {
    var _this;

    _classCallCheck(this, ArrayValidationError);

    _this = _super.call(this, valueName, value, 'Array', errors);
    _this.name = 'ArrayValidationError';
    return _this;
  }

  return ArrayValidationError;
}(ValidationError);
var array = function array() {
  var validate = arguments.length === 1 ? arguments.length <= 0 ? undefined : arguments[0] : union.apply(void 0, arguments);
  return of(function (valueName, value) {
    if (!Array.isArray(value)) {
      return new ValidationError(valueName, value, 'Array');
    }

    var errors = value.reduce(function (acc, item, index) {
      var result = validate("".concat(valueName, "[").concat(index, "]"), item);
      if (result instanceof ValidationError) acc.push(result);
      return acc;
    }, []);
    return errors.length ? new ArrayValidationError(valueName, value, errors) : value;
  });
};
var isArray = array;
var passArray = array;
var arr = array;
var isArr = array;
var passArr = array;

var boolean = of(function (name, value) {
  return typeof value == 'boolean' ? value : new ValidationError(name, value, 'boolean');
});
var isBoolean = boolean;
var passBoolean = boolean;
var bool = boolean;
var isBool = boolean;
var passBool = boolean;

var IntersectionError = /*#__PURE__*/function (_ValidationError) {
  _inherits(IntersectionError, _ValidationError);

  var _super = _createSuper(IntersectionError);

  function IntersectionError(valueName, value, errors) {
    var _this;

    _classCallCheck(this, IntersectionError);

    _this = _super.call(this, valueName, value, 'Intersection', errors);
    _this.name = 'IntersectionError';
    return _this;
  }

  return IntersectionError;
}(ValidationError);
function intersection() {
  for (var _len = arguments.length, rules = new Array(_len), _key = 0; _key < _len; _key++) {
    rules[_key] = arguments[_key];
  }

  var validators = rules;

  var intersectionContract = function intersectionContract(name, value) {
    var errors = validators.map(function (validate) {
      return validate(name, value);
    }).reduce(function (scope, error) {
      if (error instanceof ValidationError) scope.push(error);
      return scope;
    }, []);
    return errors.length ? new IntersectionError(name, value, errors) : value;
  };

  return of(intersectionContract);
}

var nul = of(function (name, value) {
  return value === null ? value : new ValidationError(name, value, 'null');
});
var isNull = nul;
var passNull = nul;

var number = of(function (name, value) {
  return typeof value == 'number' ? value : new ValidationError(name, value, 'number');
});
var isNumber = number;
var passNumber = number;
var num = number;
var isNum = number;
var passNum = number;

var ObjectValidationError = /*#__PURE__*/function (_ValidationError) {
  _inherits(ObjectValidationError, _ValidationError);

  var _super = _createSuper(ObjectValidationError);

  function ObjectValidationError(valueName, value, errors) {
    var _this;

    _classCallCheck(this, ObjectValidationError);

    _this = _super.call(this, valueName, value, 'Object', errors);
    _this.name = 'ObjectValidationError';
    return _this;
  }

  return ObjectValidationError;
}(ValidationError);

var MustBeExactError = /*#__PURE__*/function (_ValidationError) {
  _inherits(MustBeExactError, _ValidationError);

  var _super = _createSuper(MustBeExactError);

  function MustBeExactError(objectValueName, keyValueName, value) {
    var _this;

    _classCallCheck(this, MustBeExactError);

    _this = _super.call(this, "".concat(objectValueName, ".").concat(keyValueName), value);
    _this.name = 'MustBeExactError';
    _this.message = "Object `".concat(objectValueName, "` must be exact but have excess `").concat(keyValueName, "` property");
    return _this;
  }

  return MustBeExactError;
}(ValidationError);
function object(spec) {
  return of(function (valueName, value) {
    if (!value || _typeof(value) != 'object' || Array.isArray(value)) {
      return new ValidationError(valueName, value, 'Object');
    }

    var errors = Object.entries(spec).reduce(function (acc, _ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          validate = _ref2[1];

      var result = validate("".concat(valueName, ".").concat(key), value[key]);
      if (result instanceof ValidationError) acc.push(result);
      return acc;
    }, []);
    return errors.length ? new ObjectValidationError(valueName, value, errors) : value;
  });
}
var isObject = object;
var passObject = object;
var obj = object;
var isObj = object;
var passObj = object;

function objectOf() {
  var validate = union.apply(void 0, arguments);
  return of(function (valueName, value) {
    if (!value || _typeof(value) != 'object' || Array.isArray(value)) {
      return new ValidationError(valueName, value, 'Object');
    }

    var errors = Object.entries(value).reduce(function (acc, _ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          val = _ref2[1];

      var result = validate("".concat(valueName, ".").concat(key), val);
      if (result instanceof ValidationError) acc.push(result);
      return acc;
    }, []);
    return errors.length ? new ObjectValidationError(valueName, value, errors) : value;
  });
}
var isObjectOf = objectOf;
var passObjectOf = objectOf;
var objOf = objectOf;
var isObjOf = objectOf;
var passObjOf = objectOf;

function shape(spec) {
  return object(Object.entries(spec).reduce(function (acc, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        validate = _ref2[1];

    acc[key] = function (valueName, value) {
      return value === undefined ? value : validate(valueName, value);
    };

    return acc;
  }, {}));
}

var string = of(function (name, value) {
  return typeof value == 'string' ? value : new ValidationError(name, value, 'string');
});
var isString = string;
var passString = string;
var str = string;
var isStr = string;
var passStr = string;

var undef = of(function (name, value) {
  return value === undefined ? value : new ValidationError(name, value, 'void');
});
var isUndefined = undef;
var passUndefined = undef;
var isUndef = undef;
var passUndef = undef;
var isVoid = undef;
var passVoid = undef;

exports.ArrayValidationError = ArrayValidationError;
exports.IntersectionError = IntersectionError;
exports.MustBeExactError = MustBeExactError;
exports.UnionError = UnionError;
exports.ValidationError = ValidationError;
exports.arr = arr;
exports.array = array;
exports.bool = bool;
exports.boolean = boolean;
exports.intersection = intersection;
exports.isArr = isArr;
exports.isArray = isArray;
exports.isBool = isBool;
exports.isBoolean = isBoolean;
exports.isLit = isLit;
exports.isLiteral = isLiteral;
exports.isNull = isNull;
exports.isNum = isNum;
exports.isNumber = isNumber;
exports.isObj = isObj;
exports.isObjOf = isObjOf;
exports.isObject = isObject;
exports.isObjectOf = isObjectOf;
exports.isStr = isStr;
exports.isString = isString;
exports.isUndef = isUndef;
exports.isUndefined = isUndefined;
exports.isUni = isUni;
exports.isUnion = isUnion;
exports.isVoid = isVoid;
exports.lit = lit;
exports.literal = literal;
exports.nul = nul;
exports.num = num;
exports.number = number;
exports.obj = obj;
exports.objOf = objOf;
exports.object = object;
exports.objectOf = objectOf;
exports.of = of;
exports.passArr = passArr;
exports.passArray = passArray;
exports.passBool = passBool;
exports.passBoolean = passBoolean;
exports.passLit = passLit;
exports.passLiteral = passLiteral;
exports.passNull = passNull;
exports.passNum = passNum;
exports.passNumber = passNumber;
exports.passObj = passObj;
exports.passObjOf = passObjOf;
exports.passObject = passObject;
exports.passObjectOf = passObjectOf;
exports.passStr = passStr;
exports.passString = passString;
exports.passUndef = passUndef;
exports.passUndefined = passUndefined;
exports.passUni = passUni;
exports.passUnion = passUnion;
exports.passVoid = passVoid;
exports.shape = shape;
exports.str = str;
exports.string = string;
exports.undef = undef;
exports.uni = uni;
exports.union = union;
